import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as state from '../../../../../../../../../../state'
import * as content from '../../../../../../../../content'

/**
 * Presents an {@link ents.core.quiver.Evaluation.Incomplete}
 */
@ngCore.Component({
  imports: [content.display.variable.Component],
  selector: 'atn-quiver-deployment-modal-evaluation-step-incomplete',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * {@link ents.core.quiver.Evaluation.Incomplete} to be presented
   */
  public readonly evaluationSg =
    ngCore.input<ents.core.quiver.Evaluation.Incomplete>(undefined, {
      alias: 'evaluation',
    })

  /** @see {@link state.quiver.evaluation.Feature} */
  public readonly evaluationFeature = ngCore.inject(
    state.quiver.evaluation.Feature,
  )

  /**
   * Uses {@link state.quiver.evaluation.Feature} to store a variable value
   */
  public onVariableValueChange(
    variable: ents.core.dms.data.query.Variable,
    value: unknown,
  ) {
    if (value !== undefined) {
      // Values are sometimes initially set to `undefined`. Those can be ignored
      this.evaluationFeature.actions.putVariableValues
        .from(`DeploymentModal.Evaluation.Variable:${variable.id}`)
        .dispatch({ [variable.id]: value })
    }
  }
}
